import React, { FC, useMemo } from 'react';
import { Card } from 'antd';
import {
	getWorkOrderTimeZoneId,
	nullSafeGet,
	nullSafeGetOrElse,
} from '../../utils/DataAccessUtils';
import OWTaskComponent from './OWTaskComponent';

const WOTaskSectionView: FC<any> = ({
	tasks,
	loading,
	extra,
	workOrder,
	isAllowedToEdit = false,
	bulkUpdateTasks = () => {},
	bulkDeleteTasks = () => {},
	onTaskEdit = () => {},
	onTaskDelete = () => {},
	setExistingTasks = () => {},
}): React.ReactElement => {
	const taskCount = useMemo(() => {
		const validTasks = tasks.filter((_) => !!nullSafeGetOrElse('title', _, '').trim());
		const completedTasks = validTasks.filter(
			(_) => nullSafeGetOrElse('answer', _, 'false') === 'true'
		);
		return `(${completedTasks.length}/${validTasks.length})`;
	}, [tasks]);

	return (
		<Card
			title={
				<div className="flex flex-row items-center">
					<div className="mr-2">Tasks</div>
					<div className="mr-2">{taskCount}</div>
				</div>
			}
			loading={loading}
			extra={extra}
		>
			<OWTaskComponent
				existingTasks={tasks}
				isAllowedToEdit={isAllowedToEdit}
				bulkUpdateTasks={bulkUpdateTasks}
				bulkDeleteTasks={bulkDeleteTasks}
				onTaskEdit={onTaskEdit}
				onTaskDelete={onTaskDelete}
				timezonId={getWorkOrderTimeZoneId(workOrder)}
				onTasksChange={setExistingTasks}
				workOrder={workOrder}
			/>
		</Card>
	);
};

export default WOTaskSectionView;
